import * as React from "react";
import * as AV from "../AVCore/AVCore";
import { useEffect, useState } from "react";
import {
  setIsConvoScreenOpen,
  setLoginLink,
  setUser,
  setEntitydata,
  setusersLang,
  setuserisguardian,
  setLastFeedUpdate,
  setOnlineStatus,
} from "../Redux/Actions/userActions";
import { setAlerts } from "../Redux/Actions/alertActions";
import { setConvo } from "../Redux/Actions/convoActions";
import { Router, routes } from "../Platform/Routes";
import { PageLoader } from "../components/loaders";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Config } from "../App/Config";
import Moment from "moment";
import { Alert } from "../AVCore/Alert";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import ErrorHandlerPopup from "../components/common/ErrorHandlerPopup";
import { setEntityToken } from "../Redux/Actions/userActions";
import { SignalRService } from "../AVCore/SignalR";
import { setFeedsScrollUpdate } from "../Redux/Actions/feedsAction";

function Main() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [Unauthor, setUnauthor] = React.useState(false);
  const useralertList = useSelector(
    (state: RootStateOrAny) => state?.alerts.alert[0],
  );
  const loginLink = useSelector(
    (state: RootStateOrAny) => state.user.loginLink,
  );
  const entityToken = useSelector(
    (state: RootStateOrAny) => state?.user.entityToken,
  );
  const userisguardian = useSelector(
    (state: RootStateOrAny) => state?.user.userisguardian,
  );
  const convoval = useSelector((state: RootStateOrAny) => state.convo.convo[0]);
  const deviceFCMToken = useSelector(
    (state: RootStateOrAny) => state.user.devicefcmtoken,
  );
  const lastUpdateFeed = useSelector(
    (state: RootStateOrAny) => state.user.lastUpdateFeed,
  );
  const entitydatalist = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const [isShowfollow, setisShowfollow] = React.useState(true);
  const [isLandingPage, setIsLandingPage] = React.useState(false);
  const [entityLink, setentityLink] = React.useState<any>("");
  const user = useSelector((state: RootStateOrAny) => state?.user?.user[0]);
  const userLang = useSelector(
    (state: RootStateOrAny) => state?.user?.userLang[0],
  );
  const [duplicateConvo, setDuplicateConvo] = React.useState<any>([]);
  Moment.locale(user?.preferences?.lang);
  let Duplicateone: AV.IConversation[] = [];

  async function init() {
    location.state = "";
    await Config.init();
    await SignalRService.start();
    //await SignalRService.lostFocus();
    dispatch(setIsConvoScreenOpen({ isOpen: false, convoId: null }));

    if (new URLSearchParams(window.location.search) !== null) {
      let pathname = window.location.pathname;
      // If URL contains /Link/, remove it
      if (pathname.startsWith("/Link/")) {
        pathname = pathname.replace("/Link", "");
      }

      if (pathname === "/Invite" || pathname === "Activate") {
        if (new URLSearchParams(window.location.search).get("id") !== null) {
          let id =
            new URLSearchParams(window.location.search).get("id") || undefined;
          let region = new URLSearchParams(window.location.search).get(
            "region",
          );
          let token =
            new URLSearchParams(window.location.search).get("token") ||
            undefined;
          let type =
            new URLSearchParams(window.location.search).get("type") ||
            undefined;
          let fk: AV.IFK = {
            id: id,
            pk: id?.substr(-4),
            region: region,
            type: "Person",
          };
          let tokenreq: AV.ITokenRequest = {
            token: token,
            fk: fk,
            type: type,
          };
          let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
          if (actaivateperson?.id) {
            navigate(
              `/profile/${actaivateperson?.id}/${actaivateperson?.region}`,
              {
                state: {
                  user: {
                    id: actaivateperson?.id,
                    pk: actaivateperson?.pk,
                    region: actaivateperson?.region,
                    type: actaivateperson?.type,
                    name: actaivateperson?.name,
                  },
                },
              },
            );
          } else if (actaivateperson?.number === -2146233088) {
            setUnauthor(true);
          }
          navigate("/");
        }
      } else if (pathname === "/Event") {
        if (new URLSearchParams(window.location.search).get("id") !== null) {
          let id = new URLSearchParams(window.location.search).get("id");
          let region = new URLSearchParams(window.location.search).get(
            "region",
          );
          let fk: AV.IFK = {
            id: id,
            type: "Event",
            region: region,
            pk: id?.substr(-4),
          };
          navigate(`/Events/${fk?.id}/${fk?.region}/new`, {
            state: { eventdata: fk },
          });
        }
      }
      //else if (pathname === "/Post") {
      //  if (new URLSearchParams(window.location.search).get("id") !== null) {
      //    let id = new URLSearchParams(window.location.search).get("id");
      //    let pk = new URLSearchParams(window.location.search).get("pk");
      //    let region = new URLSearchParams(window.location.search).get(
      //      "region",
      //    );
      //    let fk: AV.IFK = { id: id, pk: pk, region: region, type: "Post" };
      //    navigate("/", { state: { previewdata: fk } });
      //  }
      //}
      //else if (pathname === "/Convo" || pathname === "/GroupConvo") {
      //  if (new URLSearchParams(window.location.search).get("id") !== null) {
      //    let id = new URLSearchParams(window.location.search).get("id");
      //    let pk = new URLSearchParams(window.location.search).get("pk");
      //    let region = new URLSearchParams(window.location.search).get(
      //      "region"
      //    );

      //    if (pathname === "/Convo") {
      //      let fk: AV.IFK = { id: id, pk: pk, region: region };
      //      navigate("/", { state: { convovalue: fk } });
      //    } else {
      //      let HuddleData: any = user?.orgs?.filter(
      //        (x) => x?.data == pk
      //      );
      //      navigate(`/huddles/${HuddleData[0]?.id ?? pk}`, {
      //        state: {
      //          HuddleData: HuddleData[0]
      //        },
      //      });
      //    }
      //  }
      //}
      else if (pathname?.startsWith("/Follow")) {
        let token = pathname.replace(/^\/Follow\//, "");
        let val: any = await AV.AVEntity.getTokenRequest(token, "Follow");
        let returnvalue = await val.json();
        setisShowfollow(true);
        setIsLandingPage(true);
        if (returnvalue?.id) {
          setentityLink(returnvalue);
          dispatch(setEntityToken(returnvalue));
        }
        if (token) {
          let tokenreq: AV.ITokenProcessRequest = {
            token: token,
            entity: returnvalue,
            type: "Follow",
          };
          let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
          if (actaivateperson?.id) {
            dispatch(setUser(actaivateperson));
            handleNavigate(returnvalue);
            /*navigate('/');*/
          } else if (actaivateperson?.number === -2146233088) {
            setUnauthor(true);
          }
        } else {
          let val: any = await AV.AVEntity.getTokenRequest(token, "Follow");
          let returnvalue = await val.json();
          setisShowfollow(true);
          //setIsLandingPage(true);
          if (returnvalue) {
            setentityLink(returnvalue);
            dispatch(setEntityToken(returnvalue));
          }
        }
      } else if (pathname?.startsWith("/Join")) {
        let token = pathname.replace(/^\/Join\//, "");
        let val: any = await AV.AVEntity.getTokenRequest(token, "Join");
        let returnvalue = await val.json();
        let tokenreq: AV.ITokenProcessRequest = {
          token: token,
          entity: returnvalue,
          type: "Join",
        };
        let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
        if (actaivateperson?.id) {
          dispatch(setUser(actaivateperson));
          handleNavigate(returnvalue);
        } else if (actaivateperson?.number === -2146233088) {
          setUnauthor(true);
        }
      } else if (
        pathname?.startsWith("/Invite") ||
        pathname?.startsWith("/LeagueTeamInvite")
      ) {
        const parts = window.location.pathname.split("/");
        const type = parts[2];
        const token = parts[3];
        if (
          (entityToken && entityToken?.length != 0) ||
          pathname?.startsWith("/LeagueTeamInvite")
        ) {
          let val: any = await AV.AVEntity.getTokenRequest(token, type);
          const text = await val.text();
          if (!text) {
            setUnauthor(true);
            setIsLoading(false);
            return;
          }
          const returnvalue = JSON.parse(text);
          let tokenreq: AV.ITokenProcessRequest = {
            token: token,
            entity: returnvalue,
            type: type,
          };
          let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
          if (actaivateperson?.id) {
            dispatch(setUser(actaivateperson));
            handleNavigate(returnvalue, type, token);
          } else if (actaivateperson?.number === -2146233088) {
            setUnauthor(true);
          }
        }
      } else if (pathname?.startsWith("/AddPlayer")) {
        let token = pathname.replace(/^\/AddPlayer\//, "");
        let val: any = await AV.AVEntity.getTokenRequest(token, "AddPlayer");
        let returnvalue = await val.json();
        let tokenreq: AV.ITokenProcessRequest = {
          token: token,
          entity: returnvalue,
          type: "AddPlayer",
        };
        let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
        if (actaivateperson?.id) {
          dispatch(setUser(actaivateperson));
          handleNavigate(returnvalue);
        } else if (actaivateperson?.number === -2146233088) {
          setUnauthor(true);
        }
      } else if (pathname?.startsWith("/AddStaff")) {
        try {
          let token = pathname.replace(/^\/AddStaff\//, "");
          let val: any = await AV.AVEntity.getTokenRequest(token, "AddStaff");
          let returnvalue = await val.json();
          let tokenreq: AV.ITokenProcessRequest = {
            token: token,
            entity: returnvalue,
            type: "AddStaff",
          };
          let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
          if (actaivateperson?.id) {
            dispatch(setUser(actaivateperson));
            if (returnvalue?.type === "Channel") {
              const targetFK: AV.IFK = {
                id: returnvalue?.id,
                pk: returnvalue?.id?.substr(-4),
                region: returnvalue?.region,
                type: returnvalue?.type,
              };

              const channel: AV.IAVEntity | undefined = await AV.AVEntity.get(
                AV.AVEntity.getFk(targetFK),
              );

              if (channel?.parent) {
                const channelParent: AV.IAVEntity | undefined =
                  await AV.AVEntity.get(channel.parent);

                if (channelParent) {
                  handleNavigate(channelParent);
                }
              }
            } else {
              handleNavigate(returnvalue);
            }
          } else if (actaivateperson?.number === -2146233088) {
            setUnauthor(true);
          }
        } catch (error) {
          console.error("Error processing AddStaff token:", error);
          setUnauthor(true);
        }
      } else if (pathname?.startsWith("/Add")) {
        try {
          let token = pathname.replace(/^\/Add\//, "");
          let val: any = await AV.AVEntity.getTokenRequest(token, "Add");
          let returnvalue = await val.json();
          setisShowfollow(true);
          setIsLandingPage(true);
          if (returnvalue?.id) {
            setentityLink(returnvalue);
            dispatch(setEntityToken(returnvalue));
          }
          if (token) {
            let val: any = await AV.AVEntity.getTokenRequest(token, "Add");
            let returnvalue = await val.json();
            let tokenreq: AV.ITokenProcessRequest = {
              token: token,
              entity: returnvalue,
              type: "Add",
            };
            let actaivateperson: any = await AV.AVEntity.processToken(tokenreq);
            if (actaivateperson?.id) {
              dispatch(setUser(actaivateperson));
              if (returnvalue?.type === "Channel") {
                const targetFK: AV.IFK = {
                  id: returnvalue?.id,
                  pk: returnvalue?.id?.substr(-4),
                  region: returnvalue?.region,
                  type: returnvalue?.type,
                };

                const channel: AV.IAVEntity | undefined = await AV.AVEntity.get(
                  AV.AVEntity.getFk(targetFK),
                );

                if (channel?.parent) {
                  const channelParent: AV.IAVEntity | undefined =
                    await AV.AVEntity.get(channel.parent);

                  if (channelParent) {
                    handleNavigate(channelParent);
                  }
                }
              } else {
                handleNavigate(returnvalue);
              }
            } else if (actaivateperson?.number === -2146233088) {
              setUnauthor(true);
            }
          }
        } catch (error) {
          console.error("Error processing Add token:", error);
          setUnauthor(true);
        }
      } else if (pathname?.startsWith("/Activate")) {
        let token = pathname.replace(/^\/Activate\//, "");
        if (entityToken && entityToken?.length != 0) {
          let activateType = userisguardian ? "Guardian" : "Player";
          let tokenreq: AV.ITokenRequest = {
            token: token,
            type: activateType,
          };
          let actaivateperson = await AV.Person.activate(tokenreq);
          dispatch(setuserisguardian(false));
          if (actaivateperson?.id) {
            navigate(
              `/profile/${actaivateperson?.id}/${actaivateperson?.region}`,
              {
                state: {
                  user: {
                    id: actaivateperson?.id,
                    pk: actaivateperson?.pk,
                    region: actaivateperson?.region,
                    type: actaivateperson?.type,
                    name: actaivateperson?.name,
                  },
                },
              },
            );
          } else {
            setUnauthor(true);
          }
          navigate("/");
        }
      } else if (
        window.toString().startsWith("/api") ||
        window?.location?.pathname?.startsWith("/api")
      ) {
        navigate("/");
      }
    }

    let person = await AV.Person.getSelf(true);
    //if (user === undefined) {
    //  navigate("/");
    //}

    let pathname = window.location.pathname;
    // If URL contains /Link/, remove it
    if (pathname.startsWith("/Link/")) {
      pathname = pathname.replace("/Link", "");
    }

    if (pathname.includes("Events")) {
      const pathParts = pathname.split("/").filter(Boolean);
      const evtIndex = pathParts.indexOf("Events");
      const evtId = pathParts[evtIndex + 1]; // Get ID after 'Events'

      if (!person?.events?.find((x) => x.id === evtId)) {
        setUnauthor(true);
      }
    }

    if ("Notification" in window) {
      const permission = await Notification.requestPermission();
      console.log("Permission:", permission);
    } else {
      console.warn("This browser does not support notifications.");
    }

    if (
      person.fcm?.filter((x) => x?.token === deviceFCMToken).length === 0 &&
      deviceFCMToken !== "" &&
      deviceFCMToken != undefined &&
      deviceFCMToken?.length > 0
    ) {
      AV.Person.addFCMToken(deviceFCMToken);
    }
    if (person?.wards !== undefined && person?.wards?.length > 0)
      dispatch(setuserisguardian(true));
    let alertsval = useralertList;
    let lastAlertDate =
      Alert._startDate == undefined ? new Date(0) : Alert._startDate;
    var alertList: any = await Alert.List(lastAlertDate);
    alertList = alertList?.alerts;
    if (alertsval) alertsval = [...alertsval, ...alertList];
    if (alertsval?.length > 0) {
      for (let i = 0; i < alertList?.length; i++) {
        let excitingalerts = alertsval?.filter(
          (x) => x?.id === alertList[i]?.id,
        );
        if (excitingalerts?.length === 0) alertsval.unshift(alertList[i]);
      }
    }
    alertsval = _.uniqBy(alertsval?.length > 0 ? alertsval : alertList, "id");
    alertsval?.sort(function (a, b) {
      let c: any = new Date(b.date);
      let d: any = new Date(a.date);
      return c - d;
    });
    dispatch(setAlerts(alertsval));
    //dispatch( setLoginLink( "" ) );
    if (convoval == undefined || convoval?.length == 0) {
      await getConvo();
    } else if (
      (convoval != undefined || convoval?.length > 0) &&
      (loginLink?.id?.length === 0 || loginLink === undefined)
    ) {
      dispatch(setConvo(convoval));
    }

    if (pathname === "/Convo" || pathname === "/GroupConvo") {
      if (new URLSearchParams(window.location.search).get("id") !== null) {
        let id = new URLSearchParams(window.location.search).get("id");
        let pk = new URLSearchParams(window.location.search).get("pk");
        let region = new URLSearchParams(window.location.search).get("region");

        if (pathname === "/Convo") {
          let fk: AV.IFK = { id: id, pk: pk, region: region };
          navigate("/", { state: { convovalue: fk } });
        } else {
          let HuddleData: any = user?.orgs?.filter((x) => x?.data == pk);
          navigate(`/huddles/${HuddleData[0]?.id ?? pk}`, {
            state: {
              HuddleData: HuddleData[0],
            },
          });
        }
      }
    } else if (pathname === "/Post") {
      if (new URLSearchParams(window.location.search).get("id") !== null) {
        let id = new URLSearchParams(window.location.search).get("id");
        let pk = new URLSearchParams(window.location.search).get("pk");
        let region = new URLSearchParams(window.location.search).get("region");
        let fk: AV.IFK = { id: id, pk: pk, region: region, type: "Post" };
        navigate("/", { state: { previewdata: fk } });
      }
    }

    if (!userisguardian && loginLink?.id) {
      dispatch(setLoginLink([]));
    }

    if (
      person?.status === "NewUser" ||
      person?.status === "Deleted" ||
      person?.status === "Suspended"
    ) {
      navigate(`/profile/${person?.id}/${person?.region}`, {
        state: {
          user: {
            id: person?.id,
            pk: person?.pk,
            region: person?.region,
            type: person?.type,
            name: person?.name,
          },
        },
      });
    }

    dispatch(setUser(person));

    const upsertEntity = (entity: AV.IAVEntity) => {
      const data = [...(entitydatalist ?? [])];
      const index = data?.findIndex((x) => x?.id === entity?.id);

      if (index !== -1 && data) {
        data[index] = entity; // replace
      } else {
        data?.push(entity); // add
      }

      dispatch(setEntitydata(data));
    };

    // upsert person
    upsertEntity?.(person);

    // fetch & upsert shared plan
    const sharedPlan = await AV.AVEntity.getSharedPlan(
      AV.AVEntity.getFk(person),
    );

    if (sharedPlan) upsertEntity?.(sharedPlan);

    dispatch(setFeedsScrollUpdate(true));
    if (!userLang) {
      let val = await AV.AVEntity.langList(person);
      if (val) {
        dispatch(setusersLang([val]));
      }
    }

    setIsLoading(false);
  }

  const handleNavigate = async (item: any, type: string = "", token: string = "") => {
    if (type === "LeagueTeamInvite") {
      navigate("/", {
        state: {
          inviteToken: token,
          isLeagueTeamInvite: true,
          leagueTeamInviteFrom: item,
        },
      });
    } else {
      item?.type == "Event"
        ? navigate(`/Events/${item?.id}/${item?.region}/${item?.seriesId}`, {
            state: { team: item },
          })
        : item?.type == "LeagueTeam"
          ? navigate(`/season/${item?.id}/${item?.region}`, {
              state: { isCreate: false, team: item },
            })
          : item?.type == "Team"
            ? navigate(`/teams/${item?.id}/${item?.region}`, {
                state: { isCreate: false, team: item },
              })
            : item?.id == "b495d4e0-bf52-4690-8dc0-677db954aa72" ||
                item?.id == "b495d4e0-bf52-4690-8dc0-677db954aa71" ||
                item?.id === "b495d4e0-bf52-4690-8dc0-677db954aa7f"
              ? navigate(`/teams/${item?.id}/${item?.region}`, {
                  state: { isCreate: false, team: item, type: "Feedback" },
                })
              : item?.type == "Person" || item?.type == "Pet"
                ? navigate(`/profile/${item.id}/${item.region}`, {
                    state: {
                      user: {
                        id: item?.id,
                        pk: item?.pk,
                        region: item?.region,
                        type: item?.type,
                        name: item?.title,
                      },
                    },
                  })
                : navigate(
                    `/organizations/${item?.id}/${item?.region}/${item?.type}`,
                    {
                      state: {
                        isCreate: false,
                        orgType: item?.type,
                        team: item,
                      },
                    },
                  );
    }
  };

  //GetConvo
  const getConvo = async () => {
    let convovalue: AV.IConversation[] = [];
    let convolist;
    let person: AV.IPerson = await AV.Person.getSelf();
    const chunkSize = 10; // Define the chunk size
    const convoChunks: AV.IConvoLink[][] = [];

    // Split person.convos into chunks of 20
    for (let i = 0; i < (person.convos?.length || 0); i += chunkSize) {
      if (person.convos) {
        const chunk = person.convos.slice(i, i + chunkSize);
        convoChunks.push(chunk);
      }
    }

    // Loop through each chunk and call AV.Feed.getFeeds
    for (const chunk of convoChunks) {
      let allPosts: Array<{
        id: string;
        date: string;
        owner: AV.IFK;
        ownerType: string | null;
      }> = []; // Array to hold all unique posts

      const feedParams = chunk.map((convo) => ({
        feed: convo,
        checkArchive: false,
        startDate: new Date(0), // Adjust as needed
        forward: true,
      }));

      try {
        const feedsResponse = (await AV.Feed.getAllFeeds(
          feedParams,
        )) as AV.IConversation[];

        //Categorize the convo feeds

        //var categorizedFeeds = categorizeConvoFeeds(feedsResponse);

        //const { realtime, active, intermittent, inactive, dormant } =
        //  categorizedFeeds;
        //const allEmpty =
        //  realtime.length === 0 &&
        //  active.length === 0 &&
        //  intermittent.length === 0 &&
        //  inactive.length === 0;

        //// from feedresponse, filter feeds not as dormant feeds from categorizedFeeds
        //var filteredFeeds: AV.IConversation[] = [
        //  ...categorizedFeeds.realtime,
        //  ...categorizedFeeds.active,
        //  ...categorizedFeeds.intermittent,
        //  ...categorizedFeeds.inactive,
        //  ...(allEmpty ? dormant : []),
        //];

        // Combine all followIds, privateIds, and publicIds for each feed
        feedsResponse.forEach((feed) => {
          const feedFK = AV.AVEntity.getFk(feed);
          const currentEntityPostIds = _.uniqBy(
            [
              ...(feed?.followIds || []),
              ...(feed?.privateIds || []),
              ...(feed?.publicIds || []),
            ],
            "id",
          );

          currentEntityPostIds.forEach((postId) => {
            if (postId.id && postId.date) {
              allPosts.push({
                id: postId.id,
                date: new Date(postId.date ?? new Date()).toISOString(),
                owner: feedFK,
                ownerType: feed.type || null, // Assuming feed has a type property
              });

              if (Array.isArray(postId?.gallery) && postId.gallery.length > 0) {
                postId.gallery.forEach((galleryId) => {
                  allPosts.push({
                    id: galleryId,
                    date: new Date(postId.date ?? new Date()).toISOString(),
                    owner: feedFK,
                    ownerType: feed.type || null,
                  });
                });
              }
            } else {
              console.warn("Post ID or date is missing:", postId);
            }
          });
        });

        // Call the common function to process grouped post IDs by owner
        const groupedPostIds = await groupPosts(allPosts);

        // Prepare posts to fetch based on grouped post IDs
        let postsToFetch: AV.IPostListParam[] = [];
        for (const ownerId in groupedPostIds) {
          const { owner, postIds } = groupedPostIds[ownerId];
          postsToFetch.push({
            feed: owner,
            ids: postIds.map((post) => post.id),
          });
        }
        if (postsToFetch?.length > 0) {
          // Fetch all posts based on the combined list
          try {
            const posts = await AV.Feed.getAllPosts(postsToFetch);

            convolist = feedsResponse.map((feed) => ({
              ...feed,
              posts: posts.filter((post) => post.owner?.id === feed.id),
            }));

            convovalue.push(convolist);
          } catch (error) {
            console.error("Error fetching posts:", error);
          }
        }
      } catch (error) {
        console.error("Error fetching feeds:", error);
      }
    }
    setDuplicateConvo(convovalue.flat());
    Duplicateone = convovalue.flat();
    dispatch(setConvo(convovalue.flat()));
    GetHuddles(convovalue.flat());
  };

  //GetHuddles
  const GetHuddles = async (UserConvoValue) => {
    let Groupconvovalue: AV.IConversation[] = [];
    let Groupconvolist;
    let person: AV.IPerson = await AV.Person.getSelf();
    const chunkSize = 10; // Define the chunk size
    const GroupconvoChunks: AV.IConvoLink[][] = [];

    // Split person.convos into chunks of 20
    for (
      let i = 0;
      i < (person.orgs?.filter((x) => x.type == "Channel")?.length || 0);
      i += chunkSize
    ) {
      if (person.orgs?.filter((x) => x.type == "Channel")) {
        const chunk = person?.orgs
          ?.filter((x) => x.type == "Channel")
          ?.slice(i, i + chunkSize);
        GroupconvoChunks.push(chunk);
      }
    }

    // Loop through each chunk and call AV.Feed.getFeeds
    for (const chunk of GroupconvoChunks) {
      let allPosts: Array<{
        id: string;
        date: string;
        owner: AV.IFK;
        ownerType: string | null;
      }> = []; // Array to hold all unique posts

      const feedParams: any = chunk.map((group: any) => {
        let IsPass = group?.data?.trim()?.length > 0 ? true : false;
        if (IsPass) {
          const fk = {
            id: group?.data,
            pk: group?.data,
            region: group?.region,
            type: "GroupConvo",
          };
          return {
            feed: fk,
            checkArchive: false,
            startDate: new Date(0), // Adjust as needed
            forward: true,
          };
        }
      });
      try {
        const feedsResponse = (await AV.Feed.getAllFeeds(
          feedParams,
        )) as AV.IConversation[];

        //Categorize the convo feeds

        //var categorizedFeeds = categorizeConvoFeeds(feedsResponse);

        //const { realtime, active, intermittent, inactive, dormant } =
        //  categorizedFeeds;
        //const allEmpty =
        //  realtime.length === 0 &&
        //  active.length === 0 &&
        //  intermittent.length === 0 &&
        //  inactive.length === 0;

        //// from feedresponse, filter feeds not as dormant feeds from categorizedFeeds
        //var filteredFeeds: AV.IConversation[] = [
        //  ...categorizedFeeds.realtime,
        //  ...categorizedFeeds.active,
        //  ...categorizedFeeds.intermittent,
        //  ...categorizedFeeds.inactive,
        //  ...(allEmpty ? dormant : []),
        //];

        // Combine all followIds, privateIds, and publicIds for each feed
        feedsResponse.forEach((feed) => {
          const feedFK = AV.AVEntity.getFk(feed);
          const currentEntityPostIds = _.uniqBy(
            [
              ...(feed?.followIds || []),
              ...(feed?.privateIds || []),
              ...(feed?.publicIds || []),
            ],
            "id",
          );

          currentEntityPostIds.forEach((postId) => {
            if (postId.id && postId.date) {
              allPosts.push({
                id: postId.id,
                date: new Date(postId.date ?? new Date()).toISOString(),
                owner: feedFK,
                ownerType: feed.type || null, // Assuming feed has a type property
              });

              if (Array.isArray(postId?.gallery) && postId.gallery.length > 0) {
                postId.gallery.forEach((galleryId) => {
                  allPosts.push({
                    id: galleryId,
                    date: new Date(postId.date ?? new Date()).toISOString(),
                    owner: feedFK,
                    ownerType: feed.type || null,
                  });
                });
              }
            } else {
              console.warn("Post ID or date is missing:", postId);
            }
          });
        });

        // Call the common function to process grouped post IDs by owner
        const groupedPostIds = await groupPosts(allPosts);

        // Prepare posts to fetch based on grouped post IDs
        let postsToFetch: AV.IPostListParam[] = [];
        for (const ownerId in groupedPostIds) {
          const { owner, postIds } = groupedPostIds[ownerId];
          postsToFetch.push({
            feed: owner,
            ids: postIds.map((post) => post.id),
          });
        }
        if (postsToFetch?.length > 0) {
          // Fetch all posts based on the combined list
          try {
            const posts = await AV.Feed.getAllPosts(postsToFetch);

            Groupconvolist = feedsResponse.map((feed) => ({
              ...feed,
              posts: posts.filter((post) => post.owner?.id === feed.id),
            }));

            Groupconvovalue.push(Groupconvolist);
          } catch (error) {
            console.error("Error fetching posts:", error);
          }
        }
      } catch (error) {
        console.error("Error fetching feeds:", error);
      }
    }
    if (UserConvoValue?.length > 0) {
      let FinalConvo = [...UserConvoValue, ...Groupconvovalue.flat()];
      FinalConvo = _.uniqBy(FinalConvo, "id");
      dispatch(setConvo([...FinalConvo]));
    } else if (duplicateConvo?.length > 0) {
      let FinalConvo = [...duplicateConvo, ...Groupconvovalue.flat()];
      FinalConvo = _.uniqBy(FinalConvo, "id");
      dispatch(setConvo([...FinalConvo]));
    } else if (Duplicateone?.length > 0) {
      let FinalConvo = [...Duplicateone, ...Groupconvovalue.flat()];
      FinalConvo = _.uniqBy(FinalConvo, "id");
      dispatch(setConvo([...FinalConvo]));
    } else {
      dispatch(setConvo([...Groupconvovalue.flat()]));
    }
  };

  const groupPosts = async (
    allPosts: {
      id: string;
      date: string;
      owner: AV.IFK;
      ownerType: string | null;
    }[],
  ) => {
    let groupedPostIds: {
      [key: string]: {
        owner: any;
        postIds: { id: string; date: string }[];
        ownerType: string;
      };
    } = {};
    let previousOwnerId = "";

    // Sort all posts by date in descending order
    allPosts.sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
    );

    allPosts.forEach((post) => {
      const { owner, ownerType } = post;
      const ownerId = owner.id;

      // If the ownerId changes, create a new entry in groupedPostIds
      if (ownerId !== previousOwnerId) {
        if (ownerId && !groupedPostIds[ownerId]) {
          groupedPostIds[ownerId] = {
            owner: owner,
            postIds: [],
            ownerType: ownerType || "",
          }; // Set owner to feedFK
        }
        if (ownerId && groupedPostIds[ownerId]) {
          // Limit to top 20 posts for each owner
          if (groupedPostIds[ownerId].postIds.length < 20) {
            groupedPostIds[ownerId].postIds.push({
              id: post.id,
              date: post.date,
            });
          }
          previousOwnerId = ownerId; // Update the previousOwnerId
        }
      } else {
        // If the ownerId is the same, just add the postId to the existing owner
        if (ownerId && groupedPostIds[ownerId]) {
          // Limit to top 20 posts for each owner
          if (groupedPostIds[ownerId].postIds.length < 20) {
            groupedPostIds[ownerId].postIds.push({
              id: post.id,
              date: post.date,
            });
          }
        }
      }
    });

    console.log("Collected allPostIds:", groupedPostIds);
    return groupedPostIds;
  };

  // Function to categorize convo feeds based on lastUpdated
  const categorizeConvoFeeds = (feeds: AV.IConversation[]) => {
    const now = new Date();
    const categorizedFeeds = {
      realtime: [],
      active: [],
      intermittent: [],
      inactive: [],
      dormant: [],
    };

    feeds.forEach((feed) => {
      if (feed && feed.id) {
        // Check if feed is defined and has an id
        let category = "";
        const lastUpdated = new Date(feed.lastUpdated ?? new Date());
        const timeDiff = now.getTime() - lastUpdated.getTime(); // Calculate the time difference in milliseconds
        const hoursDiff = timeDiff / (1000 * 60 * 60); // Convert time difference to hours
        const daysDiff = timeDiff / (1000 * 60 * 60 * 24); // Convert time difference to days

        // Categorize feeds based on the time difference
        if (hoursDiff < 1) {
          category = "realtime";
          (categorizedFeeds.realtime as AV.IConversation[]).push(feed); // Feeds updated within the last hour
        } else if (hoursDiff < 24) {
          category = "active";
          (categorizedFeeds.active as AV.IConversation[]).push(feed); // Feeds updated within the last 24 hours
        } else if (daysDiff < 7) {
          category = "intermittent";
          (categorizedFeeds.intermittent as AV.IConversation[]).push(feed); // Feeds updated within the last 7 days
        } else if (daysDiff < 30) {
          category = "inactive";
          (categorizedFeeds.inactive as AV.IConversation[]).push(feed); // Feeds updated within the last 30 days
        } else {
          category = "dormant";
          (categorizedFeeds.dormant as AV.IConversation[]).push(feed); // Feeds not updated for more than 30 days
        }
      } else {
        console.warn("Feed is undefined or missing ID:", feed);
      }
    });

    return categorizedFeeds;
  };

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    async function fetchData() {
      await init();
    }

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [loginLink]);

  useEffect(() => {
    if (loginLink) {
      fetchConvos(); // fetch for impersonated user
    }
  }, [loginLink]);

  const fetchConvos = async () => {
    //await dispatch( setConvo( [] ) ) // clear cache first
    await getConvo();
  };

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      if (isMounted) {
        dispatch(setLastFeedUpdate(lastUpdateFeed));
      }
    }
    fetchData();

    return () => {
      isMounted = false;
    };
  }, [lastUpdateFeed, dispatch]);

  useEffect(() => {
    let isMounted = true;

    const addFCMToken = async () => {
      if (
        typeof deviceFCMToken === "string" &&
        deviceFCMToken.trim().length > 0
      ) {
        if (
          user !== undefined &&
          user?.fcm?.every((x) => x?.token !== deviceFCMToken)
        ) {
          const updatedUser = await AV.Person.addFCMToken(deviceFCMToken);
          if (isMounted) dispatch(setUser(updatedUser));
        }
      }
    };

    addFCMToken();

    return () => {
      isMounted = false;
    };
  }, [deviceFCMToken, user, dispatch]);

  useEffect(() => {
    const updateOnlineStatus = () => {
      dispatch(setOnlineStatus(navigator.onLine));
    };

    updateOnlineStatus();

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, [dispatch]);

  return (
    <>
      {isLoading ? (
        <PageLoader />
      ) : Unauthor ? (
        <ErrorHandlerPopup />
      ) : (
        <Router routes={routes} />
      )}
    </>
  );
}

export default React.memo(Main);
